import { LOW_RESOLUTION_LONG_EDGE_PX } from './enhanceConstants'

/** Pixel size of an image as the browser reports it after loading. */
export type ImageDimensions = {
  width: number
  height: number
}

/**
 * Whether an image should carry the low-resolution warning in the grid.
 * Unknown or zero dimensions (the image has not loaded, or failed to) are
 * not flagged: a false warning would push people to pay for an enhancement
 * they may not need.
 */
export const isLowResolution = (
  dimensions: ImageDimensions | null | undefined,
): boolean => {
  if (!dimensions) return false
  const longEdge = Math.max(dimensions.width, dimensions.height)
  if (!Number.isFinite(longEdge) || longEdge <= 0) return false
  return longEdge < LOW_RESOLUTION_LONG_EDGE_PX
}
